import {BloodConfigActions} from '../redux_constants/bloodConfig.const'

export const yTopChange = (value) => ({
	type: BloodConfigActions.UPDATE_YTOP,
	response: value,
})

export const yBottomChange = (value) => ({
	type: BloodConfigActions.UPDATE_YBOTTOM,
	response: value,
})

export const countWBCSLotWiseUpdate = (value) => ({
	type: BloodConfigActions.UPDATE_COUNT_SLOT_WISE,
	response: value,
})

export const yChanger = (y_val, txty_info, slide_info, side) => dispatch => {
	let y_pixel_transformed = (slide_info.stitched_tile_height * slide_info.stitched_y_max) - y_val
	let closest_dist = Number.MAX_VALUE
	let closest_txty = ''
	for (var key in txty_info) {
		if (txty_info.hasOwnProperty(key)) {
			if ((Math.abs(txty_info[key]['pos']['Y'] - y_pixel_transformed)) < closest_dist) {
				closest_txty = txty_info[key]
				closest_dist = Math.abs(txty_info[key]['pos']['Y'] - y_pixel_transformed)
			}
		}
	}
	console.log("change", closest_txty.y_index)
	if (side === "TOP") {
		dispatch(yTopChange(parseInt(closest_txty.y_index)))
	} else if (side === "BOTTOM") {
		dispatch(yBottomChange(parseInt(closest_txty.y_index)))
	}
}

export const updateCountSlotWise = (slot_id, count) => dispatch => {
	dispatch(countWBCSLotWiseUpdate([slot_id, count]))
}